<h2 class="text-xl font-bold">{{ title() }}</h2>

<p>{{ body() }}</p>

@if (cta()) {
  <div class="mt-4">
    <button type="button" (click)="navigate.emit()" mat-flat-button color="primary">
      {{ cta() }}
    </button>
  </div>
}
